module.exports = __webpack_public_path__ + "static/img/moren.e05758d3.png";